import { t } from 'i18next';
import { FC } from 'react';
import cx from 'classnames';
import { TPatronLevel } from '../../../common/patron';

export interface IPatronLabelProps {
  className?: string;
}

const PatronLabel: FC<IPatronLabelProps & TPatronLevel> = (props) => {
  const { level, slug, className } = props;

  return (
    <div
      className={cx(
        'patron-level',
        'patron-level-bg',
        `patron-level-bg--${level}`,
        'rio-border-radius--xx-small',
        'slds-text-align--center',
        'rio-text-shadow--normal',
        className
      )}
    >
      {t(`patreon:ranks.${slug}`)}
    </div>
  );
};

export default PatronLabel;
